"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPropertyValue = void 0;
const immer_1 = require("immer");
const isPlainObject_1 = require("../isPlainObject/isPlainObject");
const setPropertyValue = (path, formData, value) => {
    return (0, immer_1.produce)(formData, (draft) => {
        if (path.length === 0) {
            // replacing entire form data
            return value;
        }
        if (!draft) {
            draft = (typeof path[0] === 'number' ? [] : {});
        }
        let _parent = draft;
        for (let i = 0; i < path.length; i++) {
            const isLastPart = i + 1 === path.length;
            const part = path[i];
            const nextPart = path[i + 1];
            const parent = _parent;
            if (isLastPart) {
                if (value === undefined) {
                    delete parent[part];
                }
                else {
                    parent[part] = value;
                }
            }
            else {
                if (typeof nextPart === 'number') {
                    if (!parent[part] || !(parent[part] instanceof Array)) {
                        parent[part] = [];
                    }
                    _parent = parent[part];
                }
                else if (typeof nextPart === 'string') {
                    if (!parent[part] || !(0, isPlainObject_1.isPlainObject)(parent[part])) {
                        parent[part] = {};
                    }
                    _parent = parent[part];
                }
                else {
                    throw new Error(`Unexpected path part "${nextPart}".`);
                }
            }
        }
        return draft;
    });
};
exports.setPropertyValue = setPropertyValue;
//# sourceMappingURL=setPropertyValue.js.map